// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--8-1!../../../less-loader/dist/cjs.js??ref--8-2!./codeages-design.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("2eea7664", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/less/codeages-design.less
// module id = 333
// module chunks = 10